export default "__VITE_ASSET__1f055e3f__"